import axiosClient from '../../../config/api/axios.js'
import { getChatContextMessageLimit } from '@/config/api/env'
import { chatCompletionResponseSchema } from '@/schemas/chatCompletionResponse'
import { assistantMetaFromChatResponse, normalizeBlocksFromChatResponse } from './assistantMeta.js'
import { chatCompletionsPath, getChatApiNotConfiguredMessage, isChatApiConfigured } from './config.js'
import { parseChatError } from './parseChatError.js'

function trimMessagesForApi(messages) {
  const limit = getChatContextMessageLimit()
  return messages.length <= limit ? messages : messages.slice(-limit)
}

export async function postChatCompletion({ messages, signal, mode }) {
  if (!isChatApiConfigured()) {
    return { ok: false, code: 'NOT_CONFIGURED', message: getChatApiNotConfiguredMessage() }
  }
  try {
    const payload = trimMessagesForApi(messages)
    const body = mode ? { messages: payload, mode } : { messages: payload }
    const { data } = await axiosClient.post(chatCompletionsPath(), body, { signal })
    const parsed = chatCompletionResponseSchema.safeParse(data)
    if (!parsed.success) return { ok: false, code: 'INVALID_RESPONSE', message: parsed.error.message }
    const d = parsed.data
    const textRaw = d.message || d.text || d.reply || d.choices?.[0]?.message?.content || d.choices?.[0]?.text
    const text = textRaw != null ? String(textRaw).trim() : ''
    const blocks = normalizeBlocksFromChatResponse(d)
    if (!text && !blocks?.length) {
      return { ok: false, code: 'INVALID_RESPONSE', message: 'No assistant text or blocks.' }
    }
    return { ok: true, text, ...(blocks?.length ? { blocks } : {}), ...assistantMetaFromChatResponse(d) }
  } catch (err) {
    return parseChatError(err)
  }
}
